import axios from 'axios';
import { local_routes } from 'utils/Routes';

/*
export const API = axios.create({
  baseURL: process.env.REACT_APP_PK_API_URL,
  timeout: 120000, // 120 seconds
  headers: {'x-api-key': process.env.REACT_APP_PK_API_KEY}
});
*/

import { getKey,saveKey } from 'utils/Helper';

export const apiUrl = process.env.REACT_APP_PK_API_URL+'rest/';

export const baseUrl = process.env.REACT_APP_PK_API_URL;

export const searchUrl = process.env.REACT_APP_PK_API_URL+'search/';

export const events_list_api = apiUrl + "events";

export const venues_api = apiUrl + "venues";

export const channel_list_api = apiUrl + "channels";

export const events_search_list_api = baseUrl + "search/eventsearch";

export const facebook_get_access_token_api = apiUrl + "authenticate/facebook";

export const twitterApi = `${apiUrl}authenticate/twitterrequesttoken`

export const twitter_request_token = apiUrl + "authenticate/twitterrequesttoken";

export const twitter_access_token = apiUrl + "authenticate/twitteraccesstoken";

export const user_authentication = apiUrl + "authenticate/local";

export const user_Registration = apiUrl + "users/register/local";

export const support_ticket_api = apiUrl + "support_tickets";

export const Category_list_Api = apiUrl + "categories";

export const slides_Creation_API = `${apiUrl}slides`;

export const presentation_Creation_API = `${apiUrl}presentations`;

export const presentation_Collision_Check_API = `${apiUrl}presentations/checkUniqueCollision`;

export const user_API = apiUrl + "users";

export const search_Presentation_API = `${searchUrl}presentationsearch`;

export const site_Search_API = `${searchUrl}sitesearch`;

export const twitter_api = apiUrl + "authenticate/twitter";

export const managed_contents = `${apiUrl}managed_contents`;

export const managed_contents_PechaKucha_Inc = `${apiUrl}channels/pechakucha-inc`;

export const location_api = `${apiUrl}locations`;

export const location_search = `${searchUrl}locationsearch`;

export const User_Patch_Api = apiUrl + "users";

export const  locationSearchAPI = `${baseUrl}search/locationsearch`

export const environment = {
    User_Patch_Api: apiUrl + "users",
    location_Search: `${baseUrl}search/locationsearch`
};

export function Category_list_Api_Func() {
    return axios.get(apiUrl + "categories");
}

export let UserData = {};
export let user_account_level = "";
export let user_access_level = "";
export let user_access_token = "";
export let user_access_token_expiration = 0;
export let user_entity_uuid = "";
export let user_friendly_url = "";
export let user_Status_Ver = "";
export let user_Status = 0;
export let owner_perms = {};
export let organization_user_access_level = "";
export let org_friendly_url = "";
export let org_name = "";
export let org_account_level = "";
export let org_uuid = "";
export let user_ip = "";
export let PersistentUserState = {};

export function grabFromLocalStorage() {
    //console.log("grabFromLocalStorage");
    
    UserData = {};
    user_account_level = "";
    user_access_level = "";
    user_access_token = "";    
    user_access_token_expiration = 0;
    user_entity_uuid = "";
    user_friendly_url = "";
    user_Status_Ver = "";
    
    user_Status = 0;
    owner_perms = {};
    organization_user_access_level = "";
    org_friendly_url = "";
    org_name = "";
    org_uuid = "";
    user_ip = "";
    PersistentUserState = {};
    
    UserData = getKey("UserData");
    PersistentUserState = getKey("PersistentUserState");
    //console.log("grabFromLocalStorage",UserData,PersistentUserState);
    if (PersistentUserState) {
        if (PersistentUserState.user_friendly_url) {
            user_friendly_url = PersistentUserState.user_friendly_url;
            //console.log("Api - org_friendly_url",org_friendly_url);
        }
        if (PersistentUserState.org_friendly_url) {
            org_friendly_url = PersistentUserState.org_friendly_url;
            //console.log("Api - org_friendly_url",org_friendly_url);
        }
        if (PersistentUserState.org_name) {
            org_name = PersistentUserState.org_name;
            //console.log("Api - org_name",org_name);
        }
        if (PersistentUserState.org_account_level) {
            org_account_level = PersistentUserState.org_account_level;
            //console.log("Api - org_name",org_name);
        }
        if (PersistentUserState.org_uuid) {
            org_uuid = PersistentUserState.org_uuid;
        }
    }

    if (UserData && UserData.login_Auth_Res) {
        user_access_level = `${UserData.login_Auth_Res.access_level}`;    
        user_access_token = `Bearer ${UserData.login_Auth_Res.access_token}`;
        user_access_token_expiration = UserData.login_Auth_Res.expTime;
        if (UserData.login_Auth_Res.user_ip) {
            user_ip = UserData.login_Auth_Res.user_ip;
        }
        
        if (UserData.login_Auth_Res.account_level) {
            user_account_level = UserData.login_Auth_Res.account_level;
        } else {
            user_account_level = 'normal';
        }
        
        if (UserData.login_Auth_Res.entity_uuid) {
            user_entity_uuid = `${UserData.login_Auth_Res.entity_uuid}`;
        } else if (UserData.login_Auth_Res.user_uuid) {
            user_entity_uuid = `${UserData.login_Auth_Res.user_uuid}`;
        }
        user_Status_Ver = `${UserData.login_Auth_Res.status_code}`;
        user_Status = 1;

        // org stuff
        if (UserData.login_Auth_Res.owner_perms) {
            owner_perms = UserData.login_Auth_Res.owner_perms;
        }
        if (owner_perms['organizations'] && owner_perms['organizations'][org_friendly_url]) {
            organization_user_access_level = owner_perms['organizations'][org_friendly_url];
        }
    }
    //return [user_entity_uuid,user_access_level,user_Status_Ver];
}

grabFromLocalStorage();

//console.log("Api - UserData",UserData);
/*
export const PersistentUserState = getKey("PersistentUserState");
//console.log("Api - PersistentUserState",PersistentUserState);
export let org_friendly_url = "";
export let org_name = "";

if (PersistentUserState) {
    if (PersistentUserState.org_friendly_url) {
        org_friendly_url = PersistentUserState.org_friendly_url;
        //console.log("Api - org_friendly_url",org_friendly_url);
    }
    if (PersistentUserState.org_name) {
        org_name = PersistentUserState.org_name;
        //console.log("Api - org_name",org_name);
    }
}



if (UserData !== null && UserData !== undefined) {
    user_access_level = `${UserData.login_Auth_Res.access_level}`;    
    user_access_token = `Bearer ${UserData.login_Auth_Res.access_token}`;
    if (UserData.login_Auth_Res.entity_uuid) {
        user_entity_uuid = `${UserData.login_Auth_Res.entity_uuid}`;
    } else if (UserData.login_Auth_Res.user_uuid) {
        user_entity_uuid = `${UserData.login_Auth_Res.user_uuid}`;
    }
    user_Status_Ver = `${UserData.login_Auth_Res.status_code}`;
    user_Status = 1;
    
    // org stuff
    if (UserData.login_Auth_Res.owner_perms) {
        owner_perms = UserData.login_Auth_Res.owner_perms;
    }
    if (owner_perms['organizations'] && owner_perms['organizations'][org_friendly_url]) {
        organization_user_access_level = owner_perms['organizations'][org_friendly_url];
    }
}
*/

/*
const user_access_level_temp = getKey("UserData") === null || undefined ? "" : `${UserData.login_Auth_Res.access_level}`;
export const user_access_level = user_access_level_temp;
const user_access_token_temp = getKey("UserData") === null || undefined ? "" : `Bearer ${UserData.login_Auth_Res.access_token}`;
export const user_access_token = user_access_token_temp;
const user_entity_uuid_temp = getKey("UserData") === null || undefined ? "" : `${UserData.login_Auth_Res.entity_uuid}`;
export const user_entity_uuid = user_entity_uuid_temp;
let user_friendly_url_temp = "";
if (getKey("UserData") && UserData.login_Auth_Res.friendly_url && UserData.login_Auth_Res.status_code === 1) {
    user_friendly_url_temp = UserData.login_Auth_Res.friendly_url;
}
export const user_friendly_url = user_friendly_url_temp;
const user_status_temp = getKey("UserData") === null || undefined ? "" : `${UserData.login_Auth_Res.status_code}`;
export const user_Status_Ver = user_status_temp;
const user_Status_temp2 = getKey("UserData") === null || undefined ? 0 : 1;
export const user_Status = user_Status_temp2;
*/

//console.log(`Api - user_access_token:${user_access_token} --------------- user_entity_uuid:${user_entity_uuid} -- user_Status_Ver:${user_Status_Ver} -- user_Status:${user_Status}`)

// JBB - 11/1/2019 - this 'new Headers()' line was causing fatal error on some devices
//export const myHeaders = new Headers();
//myHeaders.append('Content-Type', 'application/json');
//myHeaders.append('x-api-key', process.env.REACT_APP_PK_API_KEY);

export const myHeaders_Authorized = {
    headers: {
        'x-api-key': process.env.REACT_APP_PK_API_KEY,
        'Content-Type': 'application/json',
        Authorization: user_access_token
    },
};

// JBB - 1/22/2020 - mis-spelling...will deprecate when convenient
export const myHeaders_Autorized = {
    headers: {
        'x-api-key': process.env.REACT_APP_PK_API_KEY,
        'Content-Type': 'application/json',
        Authorization: user_access_token
    },
};

export const HeaderConfig = {
    headers: {
        'x-api-key': process.env.REACT_APP_PK_API_KEY,
        'Content-Type': 'application/json'
    }
};

export const myHeaders_Auth_With_Cache_Control = {
    headers: {
        'x-api-key': process.env.REACT_APP_PK_API_KEY,
        'Content-Type': 'application/json',
        'Cache-Control': 'max-age=0',
        Authorization: user_access_token
    },
};

export const myHeaders_With_Cache_Control = {
    headers: {
        'x-api-key': process.env.REACT_APP_PK_API_KEY,
        'Content-Type': 'application/json',
        'Cache-Control': 'max-age=0',
    },
};


// Add a request interceptor
axios.interceptors.request.use(
    function (config) {
        // Do something before request is sent
        // In case we are using axios for something besides API calls (like S3 signed-url PUT), make sure we are only intercepting what we want
        if (config.url.indexOf(process.env.REACT_APP_PK_API_URL) !== -1) {
            // always use api-key
            if (!config.headers['x-api-key']) {
                config.headers['x-api-key'] = process.env.REACT_APP_PK_API_KEY;
            }
            // from API we are always requesting json
            if (!config.headers['Content-Type']) {
                config.headers['Content-Type'] = 'application/json';
            }
            // if in a workspace, pass the org in an extra header
            //console.log("Api - interceptor - org_friendly_url",org_friendly_url);
            if (org_friendly_url && user_access_token) {
                if (!('X-PK-Organization' in config.headers)) {
                    //config.headers['X-PK-Organization'] = org_friendly_url;
                }
                config.headers['Authorization'] = user_access_token;
            } else if (config.method !== 'get' && user_access_token && !config.headers['Authorization']) {
                // a few 'get' calls will need to explicitly add the Authorization header. 'put' operations will be S3 signed-url puts, so we don't want the header in that case.
                config.headers['Authorization'] = user_access_token;
            }
        }
        return config;
    },
    function (error) {
        // Do something with request error
        return Promise.reject(error);
    }
);

// Add a response interceptor
axios.interceptors.response.use(
    function (response) {
        // Any status code that lie within the range of 2xx cause this function to trigger
        // Do something with response data
        if (response.headers && response.headers['x-auth-token']) {
            if (response.headers['x-auth-token'] === 'falsify') {
                // special case where user's access has changed. We just need to make sure they are logged out.
                console.error("USER ACCESS CHANGED! Force logout");
                window.localStorage.clear();
                window.location.href = window.location.origin;
                return;
            }
            // replace user access_token
            let UserData = getKey('UserData');
            if (UserData && UserData.login_Auth_Res && (UserData.login_Auth_Res.access_token !== response.headers['x-auth-token'])) {
                // The API can return a cached response, so it will sometimes return the same x-auth-token that we already have
                UserData.login_Auth_Res.access_token = response.headers['x-auth-token'];
                saveKey("UserData", JSON.stringify(UserData));
            }
        }
        return response;
    },
    function (error) {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Do something with response error
        console.error("API ERROR",JSON.stringify(error.response,null,2));
        if (error.response) {
            if (error.response['status'] === 429) {
                // we hit a limit - handle in code
                return Promise.reject(error.response);
            } else if (error.response['status'] === 403 || error.response['status'] === 400) {
                if (error.response.data) {
                    // some 403s we want to let React code handle on their own
                    let tmp_message = "unknown";
                    if (error.response.data.message) {
                        // sane PK API 403 authorization-related message
                        if (error.response.data.message.startsWith('unique attribute collision')) {
                            // handled on component
                            return Promise.reject(error);
                        } else if (error.response.data.message.startsWith('resetpassword token not found')) {
                            // handled in component
                            return Promise.reject(error);
                        } else if (error.response.data.message.startsWith('User has already verified their email') || error.response.data.message.startsWith('user not in unverified state')) {
                            return Promise.reject(error.response);
                        } else if (error.config && error.config.data && error.config.data.includes('is_online')) {
                          return Promise.reject(error.response);
                        }
                        tmp_message = error.response.data.message;
                    } else if (error.response.data.error && error.response.data.error.message) {
                        // sane PK API 400 validation error
                        tmp_message = error.response.data.error.message;
                    } else if (error.response.config && error.response.config.url && error.response.config.url.indexOf('api.hsforms.com') >= 0) {
                      // hubspot API throws errors sometimes - just hide them
                      return Promise.reject(error);
                    } else {
                        // some other 403 - probably API Gateway or S3
                        if (error.response.headers['content-type'] && error.response.headers['content-type'] === 'application/xml') {
                            // S3 returns xml
                            let parser = new window.DOMParser();
                            let xmlDoc = parser.parseFromString(error.response.data,"text/xml");
                            tmp_message = xmlDoc.getElementsByTagName("Message")[0].childNodes[0].nodeValue;
                        } else {
                            // not sure?
                            tmp_message = error.response.data;
                        }
                    }
                    /*
                    } else if (error.response.data.startsWith("<?xml")) {
                        // probably a bad response from PUT (AWS signed URL)
                        let parser = new window.DOMParser();
                        let xmlDoc = parser.parseFromString(error.response.data,"text/xml");
                        tmp_message = xmlDoc.getElementsByTagName("Message")[0].childNodes[0].nodeValue;
                        
                    }
                    */
     
                    
                    // user should be redirected to login page
                    //localStorage.clear();
                    //window.location.href = window.location.origin+'/login';
                    let d = new Date(); 
                    let date_string = d.toUTCString()+' ('+Math.floor(d.getTime() / 1000)+')';
                    let error_message = date_string+'\n'+error.response['status']+' '+error.response['statusText']+'\n'+tmp_message;
                    if (user_entity_uuid) {
                        error_message = error_message+'\nUser '+user_entity_uuid;
                    }
                    if (error.response.config.url && error.response.config.method) {
                        error_message = error_message+'\n'+error.response.config.method+' '+error.response.config.url;
                    }
                    if (error.response.config.data) {
                        error_message = error_message+'\n'+JSON.stringify(error.response.config.data);
                    }
                    window.localStorage.setItem("pk_error_message",error_message);
                    //window.localStorage.removeItem("UserData");
                    //window.localStorage.removeItem("PersistentUserState");
                    window.location.href = window.location.origin+'/error';
                    return;
                    
                } else {
                    // user should be redirected to login page
                    window.localStorage.clear();
                    //localStorage.removeItem("UserData");
                    //localStorage.removeItem("PersistentUserState");
                    window.location.href = window.location.origin+'/login';
                    return;
                }
            } else if (error.response['status'] === 404) {
                if (error.response.config && error.response.config.url && error.response.config.url.indexOf('/rest/users/getByEmail') >= 0) {
                    // this is ok - coming from manage workspace users, return error but do not send to 404
                    return Promise.reject(error.response);
                } else if (error.response.config && error.response.config.url && error.response.config.url.indexOf('/rest/managed_contents/public_site') >= 0) {
                    return Promise.reject(error.response);
                } else if (error.response.data && error.response.data.message && error.response.data.message.startsWith('User not found')) {
                    // this is ok - coming from resetpassword, return error but do not send to 404
                } else if (error.response.config && error.response.config && error.config.method === 'get' && error.response.config.url.indexOf('.audience/') >= 1) {
                    return Promise.reject(error.response);
                } else if (error.response.config.method === 'patch') {
                  // this should never happen, but use case is if elasticsearch has faulty data
                  return Promise.reject(error.response);
                } else {
                    // user should be redirected to 404
                    if (org_friendly_url) {
                        window.location.href = window.location.origin+local_routes.workspace+"/"+org_friendly_url+local_routes.not_found;
                    } else {
                        window.location.href = window.location.origin+local_routes.not_found;
                    }
                    //localStorage.clear();
                    //window.location.href = window.location.origin+'/login';
                    return;
                }
            } else {
                // some other error, like 422 (verification code does not match)
                //return Promise.reject(error);
            }
            return Promise.reject(error);
        }
    }
);

export function ApiGet (api_endpoint,header_config) {
    let results = axios.get(api_endpoint,header_config);
    return results;
}
